
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import PlatformMarkerLogMid from "../../editor/platform-markers/shipwreck/PlatformMarkerLogMid";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationJungleIsland from "../../decorations/shipwreck/DecorationJungleIsland";
import FinishMarker from "../../editor/FinishMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerLogLong from "../../editor/platform-markers/shipwreck/PlatformMarkerLogLong";
import PlatformMarkerLog from "../../editor/platform-markers/shipwreck/PlatformMarkerLog";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckEndChunk extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 412);

    // platformMarkerLogMid
    const platformMarkerLogMid = new PlatformMarkerLogMid(scene, 1481, -164);
    this.add(platformMarkerLogMid);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 2616, 301);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 0, 301);
    this.add(editor_bounds_left);

    // DecorationJungleIsland
    const decorationJungleIsland = new DecorationJungleIsland(scene, 1999, -34);
    this.add(decorationJungleIsland);

    // finishMarker
    const finishMarker = new FinishMarker(scene, 1479, 173);
    this.add(finishMarker);

    // pole_long_float_png_10
    const pole_long_float_png_10 = new DecorationFloatingPoleLong(scene, 897, 178);
    this.add(pole_long_float_png_10);

    // pole_long_float_png_11
    const pole_long_float_png_11 = new DecorationFloatingPoleLong(scene, 633, 178);
    this.add(pole_long_float_png_11);

    // pole_long_float_png_12
    const pole_long_float_png_12 = new DecorationFloatingPoleLong(scene, 342, 178);
    this.add(pole_long_float_png_12);

    // pole_long_float_png_13
    const pole_long_float_png_13 = new DecorationFloatingPoleLong(scene, 69, 178);
    this.add(pole_long_float_png_13);

    // platformMarkerLogLong_3
    const platformMarkerLogLong_3 = new PlatformMarkerLogLong(scene, 483, 48);
    this.add(platformMarkerLogLong_3);

    // end_foliage_png
    const end_foliage_png = scene.add.image(1352, -159, 'game-all', "end-foliage.png");
    end_foliage_png.scaleX = 1.3976478236983527;
    end_foliage_png.scaleY = 1.3976478236983527;
    this.add(end_foliage_png);

    // end_foliage_png_1
    const end_foliage_png_1 = scene.add.image(1471, -196, 'game-all', "end-foliage.png");
    this.add(end_foliage_png_1);

    // end_foliage_png_2
    const end_foliage_png_2 = scene.add.image(1650, -168, 'game-all', "end-foliage.png");
    this.add(end_foliage_png_2);

    // platformLog_5
    const platformLog_5 = new PlatformMarkerLog(scene, 944, -65);
    this.add(platformLog_5);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1528, -272);
    this.add(gemMarker);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 1235, -272);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 1381, -272);
    this.add(gemMarker_11);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1095, -134);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 802, -134);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 948, -134);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 492, -28);
    this.add(gemMarker_4);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 199, -28);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 345, -28);
    this.add(gemMarker_6);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
